type SelfServicesProps = {
  title: string
  description: string
  logoSrc: string
  posterSrc: string
  videoUrl: string
}

export const SelfServicesData: SelfServicesProps[] = [
  {
    title: 'Cribl',
    description:
      'Priya Gupta, Head of Data at Cribl, provides self-service analytics for 700+ monthly users with Omni’s AI. She shares how she uses Git and Omni’s dbt integration to deliver insights at scale.',
    logoSrc: '/images/customer-logos/cribl.svg',
    posterSrc: '/images/pages/home/testimonials/cribl-testimonial-poster.webp',
    videoUrl: 'https://www.youtube.com/embed/un-_6HMNsvk?rel=0?controls=0',
  },
  {
    title: 'Photoroom',
    description:
      'Juliette Duizabo, Head of Data at Photoroom, discusses how her data team of 3 enables her organization of 100+ people to get answers in seconds with Omni’s AI and MCP server.',
    logoSrc: '/images/customer-logos/photoroom.svg',
    posterSrc:
      '/images/pages/home/testimonials/photoroom-testimonial-poster.webp',
    videoUrl: 'https://www.youtube.com/embed/Y8RjDBUUtcA',
  },
]
